var _path, _g, _path2, _g2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDictionary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.44794 2.95703C2.44751 2.95703 2.44702 2.95703 2.44659 2.95703C2.29527 2.95703 2.15294 3.01354 2.04546 3.11623C1.9368 3.22006 1.87695 3.35832 1.87695 3.50549V11.7296C1.87695 12.0312 2.13408 12.2771 2.4502 12.2779C3.78288 12.2809 6.01565 12.547 7.55594 14.0911V5.48436C7.55594 5.38213 7.52869 5.28609 7.47724 5.20662C6.21303 3.25634 3.78363 2.96002 2.44794 2.95703Z",
    fill: "url(#paint0_linear_133_63750)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_133_63750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.44794 2C2.44751 2 2.44702 2 2.44659 2C2.29527 2 2.15294 2.05651 2.04546 2.1592C1.9368 2.26303 1.87695 2.40128 1.87695 2.54846V10.7726C1.87695 11.0741 2.13408 11.3201 2.4502 11.3209C3.78288 11.3239 6.01565 11.59 7.55594 13.1341V4.52733C7.55594 4.42509 7.52869 4.32906 7.47724 4.24958C6.21303 2.29931 3.78363 2.00299 2.44794 2Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1233 11.7296V3.50549C14.1233 3.35832 14.0634 3.22006 13.9548 3.11623C13.8473 3.01354 13.7049 2.95703 13.5537 2.95703C13.5532 2.95703 13.5527 2.95703 13.5523 2.95703C12.2166 2.96008 9.78725 3.25639 8.52299 5.20667C8.47154 5.28614 8.44434 5.38218 8.44434 5.48441V14.0911C9.98464 12.547 12.2174 12.2809 13.5501 12.2779C13.8661 12.2771 14.1233 12.0312 14.1233 11.7296Z",
    fill: "url(#paint1_linear_133_63750)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_133_63750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1233 10.7726V2.54846C14.1233 2.40128 14.0634 2.26303 13.9548 2.1592C13.8473 2.05651 13.7049 2 13.5537 2C13.5532 2 13.5527 2 13.5523 2C12.2166 2.00304 9.78725 2.29936 8.52299 4.24964C8.47154 4.32911 8.44434 4.42515 8.44434 4.52738V13.1341C9.98464 11.59 12.2174 11.3239 13.5501 11.3209C13.8661 11.3201 14.1233 11.0741 14.1233 10.7726Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4277 4.85547H15.0125V11.7314C15.0125 12.5014 14.3576 13.1293 13.5525 13.1312C12.4222 13.1338 10.5583 13.3455 9.23828 14.5423C11.5213 14.0069 13.9279 14.3549 15.2995 14.6544C15.4707 14.6917 15.6477 14.6531 15.7849 14.5484C15.9217 14.4439 16.0001 14.2877 16.0001 14.12V5.40383C16.0001 5.10147 15.7433 4.85547 15.4277 4.85547Z",
    fill: "url(#paint2_linear_133_63750)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.987576 11.7314V4.85547H0.572441C0.25686 4.85547 0 5.10147 0 5.40383V14.1198C0 14.2876 0.0784372 14.4437 0.215164 14.5482C0.352267 14.6529 0.529074 14.6917 0.700601 14.6542C2.07217 14.3547 4.47889 14.0067 6.76176 14.5422C5.44179 13.3454 3.57794 13.1338 2.44755 13.1312C1.64255 13.1293 0.987576 12.5014 0.987576 11.7314Z",
    fill: "url(#paint3_linear_133_63750)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_133_63750",
    x: -0.123047,
    y: 0,
    width: 9.6792,
    height: 15.1328,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_133_63750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_133_63750",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_133_63750",
    x: 6.44434,
    y: 0,
    width: 9.67871,
    height: 15.1328,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_133_63750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_133_63750",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_133_63750",
    x1: 4.71645,
    y1: 2.95703,
    x2: 4.71645,
    y2: 14.0911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F52F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A99BFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_133_63750",
    x1: 11.2838,
    y1: 2.95703,
    x2: 11.2838,
    y2: 14.0911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F52F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A99BFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_133_63750",
    x1: 12.6192,
    y1: 4.85547,
    x2: 12.6192,
    y2: 14.6683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F52F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A99BFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_133_63750",
    x1: 3.38088,
    y1: 4.85547,
    x2: 3.38088,
    y2: 14.6682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F52F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A99BFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDictionary);
export default __webpack_public_path__ + "static/media/dictionary.a5ca07d23f528c2a7580a1d767dd235d.svg";
export { ForwardRef as ReactComponent };